export default __webpack_public_path__ + "static/icon-25-4-b2c64d013a7a7e5f2a6041f729ff2896.png";